import script from "./TabelaVerificaoEstoqueLocalizado.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaVerificaoEstoqueLocalizado.vue?vue&type=script&setup=true&lang=js"

import "./TabelaVerificaoEstoqueLocalizado.vue?vue&type=style&index=0&id=d6d23f56&scoped=true&lang=css"
import "./TabelaVerificaoEstoqueLocalizado.vue?vue&type=style&index=1&id=d6d23f56&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6d23f56"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QSelect,QBtn,QTable,QTr,QTh,QTd,QField});
